import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@icon/menu.svg'


const _hoisted_1 = {
  key: 0,
  class: "header__menu__box"
}
const _hoisted_2 = { class: "header__menu__list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon = _resolveComponent("icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_TooltipLearn = _resolveComponent("TooltipLearn")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (!_ctx.hideHeaderMenuForUnavailableDemo)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["header__menu", { 'learn-tooltip pointer-none': _ctx.step === _ctx.selectedStep }])
      }, [
        _withDirectives((_openBlock(), _createElementBlock("button", {
          class: _normalizeClass(["header__icon-link body-text body-text-large-400", [{ clicked__button: _ctx.opened }, { 'is-disabled': !_ctx.visibleMenuItems.length }]]),
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args)))
        }, [
          _createVNode(_component_icon, {
            class: "img-icon-fill",
            data: _imports_0,
            fill: true,
            width: "var(--icon-24)",
            height: "var(--icon-24)"
          })
        ], 2)), [
          [_directive_click_outside, _ctx.hide]
        ]),
        (_ctx.showMenu)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(_component_TooltipLearn, {
                placement: "left",
                placementSub: "left",
                step: _ctx.step,
                show: _ctx.selectedStep === _ctx.step,
                autoHide: _ctx.selectedStep !== _ctx.step,
                distance: 30,
                tooltipText: _ctx.$t(`learnTooltipText.${_ctx.step}`),
                class: "header__menu__tips"
              }, {
                "tooltip-label": _withCtx(() => [
                  _createElementVNode("ul", _hoisted_2, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleMenuItems, (item, index) => {
                      return (_openBlock(), _createBlock(_component_router_link, {
                        key: index,
                        class: "header__menu__item",
                        to: item.to
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_icon, {
                            data: item.icon,
                            fill: item.fill,
                            class: "header__menu__icon",
                            color: _ctx.iconColor,
                            width: "var(--icon-32)",
                            height: "var(--icon-32)"
                          }, null, 8, ["data", "fill", "color"]),
                          _createTextVNode(" " + _toDisplayString(item.label), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"]))
                    }), 128))
                  ])
                ]),
                _: 1
              }, 8, ["step", "show", "autoHide", "tooltipText"])
            ]))
          : _createCommentVNode("", true)
      ], 2))
    : _createCommentVNode("", true)
}